import { HttpClient } from "../httpClient";
import CascadingVariable from "../models/cascadingVariable";
import CascadingVariableOverrideOptions from "../models/cascadingVariableOverrideOptions";
import { BaseResponse, DataResponse } from "../responses/baseResponse";

const httpClient = new HttpClient();

export const getCascadingVariables = async () => {
    return httpClient.get<DataResponse<CascadingVariable[]>>({
      url: '/v1/cascadingvariables',
      requiresToken: true,
    });
  };

export const getCascadingVariableById = async (id:number) => {
    return httpClient.get<DataResponse<CascadingVariable>>({
        url: `/v1/cascadingvariables/${id}`,
        requiresToken: true
    });
};

export const addEditCascadingVariable = async (rule:CascadingVariable) => {
    return httpClient.post<DataResponse<number>>({
        url: '/v1/cascadingvariables/AddEdit',
        payload: rule,
        requiresToken: true,
    });
}

export const deleteCascadingVariable = async (cascadingVariableId: number) => {
    return httpClient.delete<BaseResponse>({
        url: `/v1/cascadingvariables/${cascadingVariableId}`,
        requiresToken: true,
    });
};

export const GetCascadingVariableOverrideOptions = async () => {
    return httpClient.get<DataResponse<CascadingVariableOverrideOptions>>({
        url: `/v1/cascadingvariables/GetCascadingVariableOverrideOptions`,
        requiresToken: true
    });
};